export enum UserTypes {
    ADMIN = 'admin',
    CLIENT = 'client'
}